/*
 * Broadcast Theme - Custom JS
 *
 * Estroni 2026-07-19: strip Yotpo's duplicate Product JSON-LD.
 * The Yotpo Product Reviews "reviews" app-block emits its own Product schema whose
 * offer uses the presentment PRICE but a hardcoded AUD currencyCode (verified: on a
 * USD-presentment page it renders price 86 / currency AUD), which conflicts with the
 * theme's correct market-aware Product block on /en-us (price 86 / currency USD).
 * This removes ONLY the Yotpo app-block's Product JSON-LD, leaving the theme's block
 * as the single Product entity Google reads. It targets .shopify-app-block, so it
 * never touches the theme's own block, and it does NOT affect the visible reviews
 * widget (only the hidden structured-data script is removed).
 *
 * NOTE: this file previously held a fully commented-out (disabled, inert) "inventory-0
 * pre-order popup" prototype. It ran nothing. It was removed here for clarity; the full
 * prior version is preserved in Shopify theme edit history if it is ever needed again.
 */
(function () {
  function stripYotpoProductLd() {
    var nodes = document.querySelectorAll('.shopify-app-block script[type="application/ld+json"]');
    for (var i = 0; i < nodes.length; i++) {
      var s = nodes[i];
      if (s.textContent && s.textContent.indexOf('"Product"') !== -1) {
        s.parentNode && s.parentNode.removeChild(s);
      }
    }
  }
  stripYotpoProductLd();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stripYotpoProductLd);
  }
  // Safety net in case Yotpo hydration re-touches the block after load.
  setTimeout(stripYotpoProductLd, 2000);
})();
